// extracted by mini-css-extract-plugin
export default {"iconCheck":"styles-scoped__iconCheck--tmsWa","iconClose":"styles-scoped__iconClose--FEb8w"};